<div class="modal-header">
  <h3>Choose Vendor Ranking</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <!-- <select class="form-select" [(ngModel)]="CompanyServiceRankingId">
  <option [ngValue]="null" disabled selected>Pick one...</option>
  <option *ngFor="let item of CompanyServiceRankings" [ngValue]="item.id">{{item.priorityLevel + '. ' + item.rank }}</option>
</select> -->
  <div class="row" style="min-height: 400px">
    <div class="col">
      <app-company-service-rankings-grid
        [gridName]="'ClientSpotlightVendors'"
        [selectedRowsPrimaryKeys]="selectedPrimaryKeyRows"
        (rowClick)="actionEvent({ action: 'add', rowData: $event.data })"
      ></app-company-service-rankings-grid>
    </div>
  </div>

  @if (CompanyServiceRanking?.isTradeCategorySpecific && VendorRank) {
    <div class="row">
      <div class="col">
        <label requiredAsterisk>Trade Category?</label>
        <select class="form-select" [(ngModel)]="VendorRank.tradeCategoryName">
          <option [ngValue]="null" disabled selected>Pick one...</option>
          @for (item of tradeCategories; track item) {
            <option [ngValue]="item.categoryName">
              {{ item.categoryName }}
            </option>
          }
        </select>
      </div>
    </div>
  }

  @if (CompanyServiceRanking?.isTradeSpecific && VendorRank) {
    <div class="row">
      <div class="col">
        <label requiredAsterisk>Trade?</label>
        <select class="form-select" [(ngModel)]="VendorRank.tradeName">
          <option [ngValue]="null" disabled selected>Pick one...</option>
          @for (item of trades; track item) {
            <option
              [ngValue]="$safeNavigationMigration(item.PrimaryTrade?.name)"
            >
              {{ item.PrimaryTrade?.name }}
            </option>
          }
        </select>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    @if (CompanyServiceRankingId) {
      <div class="col-5">
        <button type="button" class="btn btn-danger" (click)="removeRank()">
          Remove Rank
        </button>
      </div>
    }
    <div class="col-4">
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!CompanyServiceRankingId"
        (click)="selectRank()"
      >
        Select Rank
      </button>
    </div>
  </div>
</div>
